import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';

const alignTop = (element: ElementType, topY: number) => {
    const box = getBoundingBox(element);
    const offsetY = element.y - box.minY;
    element.set({ y: topY + offsetY });
};

export function alignElementsTop(elements: ElementsArray) {
    const topY = elements.length > 1 ? Math.min(...elements.map(getBoundingBox).map(box => box.minY)) : 0;

    elements.forEach(element => {
        alignTop(element, topY);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignTop(child, topY);
            });
        }
    });
}
